import { useEffect, useState } from 'react';
import { Card, Tag, Checkbox } from 'antd';
import {
  getFormattedTime,
  getPriceText,
} from '@zorba-shared/core/Services/textService';
import { postRequest } from '../../../../services/requestService';
import { showErrorToast } from '../../../../services/notificationsService';
import { Spinner } from '../../../../components/Spinner';

import './index.scss';

export const AddressActivityTab = ({ address }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedSources, setSelectedSources] = useState([]);

  const getEventTitle = (event) => {
    if (event.eventType === 'Sold') {
      return 'Property was sold';
    }
    if (event.eventType === 'Deal Submission') {
      return `${event.eventAuthor} submitted to Zorba`;
    }

    return '';
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await postRequest(
          '/backoffice/buyer-checker/address-activity',
          {
            address,
          },
        );
        setData(response?.data?.data || []);
        const sources = [
          ...new Set((response?.data?.data || []).map((el) => el.source)),
        ];
        setSelectedSources(sources);
      } catch (error) {
        showErrorToast('Fetching address activity failed');
      }
      setIsLoading(false);
    };
    fetchData();
  }, []);

  const handleSourceChange = (checkedValues) => {
    setSelectedSources(checkedValues);
  };

  const uniqueSources = [...new Set(data.map((el) => el.source))];
  const filteredData = data.filter((el) => selectedSources.includes(el.source));

  if (isLoading) return <Spinner />;

  return (
    <div className="address-activity-tab">
      <div className="checkbox-filter">
        <Checkbox.Group
          options={uniqueSources}
          value={selectedSources}
          onChange={handleSourceChange}
        />
      </div>
      {filteredData.map((el) => (
        <Card className="card">
          <div className="event-container">
            <div className="left">
              <div>
                <Tag>{el.source}</Tag>
              </div>
              <span className="title">{getEventTitle(el)}</span>
              <span>
                Price: {getPriceText(el.eventPrice || 0)}{' '}
                {el.isLowestPrice && <Tag color="green">Our lowest price</Tag>}
              </span>
              {el.buyer && (
                <span>
                  Buyer: {el.buyer}{' '}
                  {el.buyerOrganization ? `(${el.buyerOrganization})` : ''}
                </span>
              )}
              {el.seller && (
                <span>
                  Seller: {el.seller}{' '}
                  {el.sellerOrganization ? `(${el.sellerOrganization})` : ''}
                </span>
              )}
              <span>Event: {el.eventType}</span>
              {el.eventAuthor && <span>Submitted by: {el.eventAuthor}</span>}
            </div>
            <div className="right">
              <span>{getFormattedTime(el.eventDate)}</span>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};
